module.exports = __webpack_public_path__ + "static/img/c-info-flash.312ae08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/carriers/c-info-flash.png
// module id = 11vD
// module chunks = 31